var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ControlProductList',{attrs:{"workflowKey":"spraying"},model:{value:(_vm.products),callback:function ($$v) {_vm.products=$$v},expression:"products"}})
}
var staticRenderFns = []

export { render, staticRenderFns }